import { render, staticRenderFns } from "./SelectionsList.vue?vue&type=template&id=56edad30&"
import script from "./SelectionsList.vue?vue&type=script&lang=js&"
export * from "./SelectionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports